export const DEFAULT_ROWS_PER_PAGE = 10;

export const ALERT_HISTORY_DEFAULT_CONTEXT = Object.freeze({
  rowsPerPage: DEFAULT_ROWS_PER_PAGE,
});
